import { createSlice } from '@reduxjs/toolkit';
import { LABELGENAPI } from '../../../API';
import { logFrontendActivity } from '../../General/activityLogger';

export const fulfillmentsLogSlice = createSlice({
    name: 'fulfillmentsLog',
    initialState: {
        data: [],
        meta: {
            page: 1,
            per_page: 10,
            start_date: new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().split('T')[0], // Default trailing 30 days
            end_date: new Date().toISOString().split('T')[0],
            sorting: JSON.stringify([{
                field: 'log_date',
                sort: 'desc',
            }])
        },
        loading: false,
        hasErrors: false,
        notification: { show: false, messageContent: "", messageType: "success" },
        batchPrintDetails: {
            data: null,
            loading: false
        }
    },
    reducers: {
        getFulfillmentsData: (state) => {
            return {
                ...state,
                loading: true,
                hasErrors: false
            }
        },
        getFulfillmentsDataSuccess: (state, action) => {
            return {
                ...state,
                data: action && action.payload && action.payload.data && action.payload.data.data,
                meta: action && action.payload && action.payload.data,
                hasErrors: false,
                loading: false
            }
        },
        getFulfillmentsDataFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: true,
                message: action && action.payload && action.payload.data && action.payload.data.message
            }
        },
        getPrintBatchData: (state) => {
            state.batchPrintDetails.loading = true;
        },
        getPrintBatchDataSuccess: (state, action) => {
            state.batchPrintDetails.loading = false;
            state.batchPrintDetails.data = action.payload; // Stores the raw array payload directly
        },
        getPrintBatchDataFailure: (state) => {
            state.batchPrintDetails.loading = false;
            state.batchPrintDetails.data = null;
        },
        clearFulfillmentPrintDetails: (state) => {
            state.batchPrintDetails.loading = false;
            state.batchPrintDetails.data = null;
        },
        resetFulfillments: (state) => {
            return {
                ...state,
                loading: false,
                hasErrors: false,
                notification: { show: false, messageContent: "", messageType: "success" }
            }
        }
    }
});

export const { getFulfillmentsData, getFulfillmentsDataSuccess, getFulfillmentsDataFailure, resetFulfillments } = fulfillmentsLogSlice.actions;

export const fetchFulfillmentsData = (meta) => {
    const qs = Object.keys(meta)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(meta[key])}`)
        .join('&');

    return (dispatch) => {
        dispatch(getFulfillmentsData());
        try {
            LABELGENAPI
                .get('/fulfillmentsInfo?' + qs)
                .then(function (response) {
                    dispatch(getFulfillmentsDataSuccess(response));
                })
                .catch(function (error) {
                    dispatch(getFulfillmentsDataFailure(error.response));
                });
        } catch (error) {
            dispatch(getFulfillmentsDataFailure());
        }
    };
};

export const { 
    getPrintBatchData, 
    getPrintBatchDataSuccess, 
    getPrintBatchDataFailure, 
    clearFulfillmentPrintDetails 
} = fulfillmentsLogSlice.actions;

// Async thunk action caller to fetch the records from the server matching the row target timeline 
export const loadFulfillmentBatchForPrinting = (userid, logDate) => dispatch => {
    dispatch(getPrintBatchData());
    try {
        LABELGENAPI.get(`/fulfillmentsInfo/print-batch-raw?date=${encodeURIComponent(logDate)}&userid=${userid}`)
            .then(function (response) {
                // response.data holds the flat Mongo collection query results matching that date
                dispatch(getPrintBatchDataSuccess(response.data));
            })
            .catch(function (error) {
                dispatch(getPrintBatchDataFailure());
            });
    } catch (error) {
        dispatch(getPrintBatchDataFailure());
    }
};

export const exportFulfillmentBatchCSV = (userid, logDate) => dispatch => {
    const logRef = crypto.randomUUID();
    try {
        LABELGENAPI.get(`/fulfillmentsInfo/export-batch?date=${encodeURIComponent(logDate)}`, { responseType: 'blob' })
            .then(function (response) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `fulfillment_orders_${logDate}.csv`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                
                logFrontendActivity({
                    group: 'REPORTS',
                    subgroup: 'FULFILLMENTS',
                    action: 'EXPORT_BATCH_SUCCESS',
                    request_data: { date: logDate },
                    response_data: { message: "CSV orders payload extracted successfully." },
                    log_ref: logRef,
                    userid: userid
                });
            });
    } catch (error) {
        console.error(error);
    }
};

export default fulfillmentsLogSlice.reducer;